import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import 'vuetify/dist/vuetify.min.css'
import axios from 'axios'
import vuetify from './plugins/vuetify';
import './assets/main.css';

require('@/store/subscriber')

// PENTRU DEPLOY
axios.defaults.baseURL = 'https://backend.testemate.ro/api'

// PENTRU LOCAL
// axios.defaults.baseURL = 'http://127.0.0.1:80/api'

Vue.use(BootstrapVue)
Vue.use(Vuetify)
Vue.config.productionTip = false

store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {
  new Vue({
    Vuetify,
    router,
    store,
    render: h => h(App),
    vuetify,

    icons: {
      iconfont: 'mdi',
    }
  }).$mount('#app')
})
